export const SelfReviewStatus = function () {
    this.reviewTemplateForm = {};
};
